import { ImageProcessingData } from "@amzn/hvh-camera-ui";

export const extractMetricData = (imageProcessingData: ImageProcessingData) => {
  const data = { ...imageProcessingData } as any;
  delete data.inputImageData;
  delete data.outputImageData;
  return data;
};
